import React, { Component } from "react";
import { Routes } from "../routes/Routes";
import { withRouter } from 'react-router-dom';

class Main extends Component {
  renderLandingPage() {
    return (
      <div style={{margin:"0 auto", paddingBottom:"10px"}}>
        <Routes {...this.props} />
      </div>
    )
  }
  renderDataPage() {
    return (
      <div style={{margin:"0 auto", maxWidth:"1024px", paddingBottom:"10px"}}>
        <Routes {...this.props} />
      </div>
    )
  }
  render() {
    return (
      this.props.location.pathname === '/'
      ?this.renderLandingPage()
      :this.renderDataPage()

    );
  }
}

export default (withRouter(Main));

/*
<div style={{margin:"0 auto", maxWidth:"1024px", paddingBottom:"10px"}}>

</div>

*/



// WEBPACK FOOTER //
// ./src/components/Main.js